import { render } from "./RegisterButtonManualDiscountDialog.vue?vue&type=template&id=6766bc95&scoped=true"
import script from "./RegisterButtonManualDiscountDialog.vue?vue&type=script&lang=js"
export * from "./RegisterButtonManualDiscountDialog.vue?vue&type=script&lang=js"

import "./RegisterButtonManualDiscountDialog.vue?vue&type=style&index=0&id=6766bc95&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6766bc95"]])

export default __exports__
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';import ClosePopup from 'quasar/src/directives/close-popup/ClosePopup.js';
import qInstall from "../../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QDialog,QCard,QCardSection,QSelect,QCardActions,QBtn});qInstall(script, 'directives', {ClosePopup});
